__turbopack_context__.v({
  "autoSizedItem": "item-collection-container-module-scss-module__LsmDza__autoSizedItem",
  "backButton": "item-collection-container-module-scss-module__LsmDza__backButton",
  "button": "item-collection-container-module-scss-module__LsmDza__button",
  "forwardButton": "item-collection-container-module-scss-module__LsmDza__forwardButton",
  "grelf": "item-collection-container-module-scss-module__LsmDza__grelf",
  "grid": "item-collection-container-module-scss-module__LsmDza__grid",
  "gridByColumnCount": "item-collection-container-module-scss-module__LsmDza__gridByColumnCount",
  "gridByColumnWidth": "item-collection-container-module-scss-module__LsmDza__gridByColumnWidth",
  "gridClampedWidth": "item-collection-container-module-scss-module__LsmDza__gridClampedWidth",
  "gridEvenColumns": "item-collection-container-module-scss-module__LsmDza__gridEvenColumns",
  "itemCollection": "item-collection-container-module-scss-module__LsmDza__itemCollection",
  "itemWrapper": "item-collection-container-module-scss-module__LsmDza__itemWrapper",
  "itemsContainer": "item-collection-container-module-scss-module__LsmDza__itemsContainer",
  "shelf": "item-collection-container-module-scss-module__LsmDza__shelf",
  "shelfClampedWidth": "item-collection-container-module-scss-module__LsmDza__shelfClampedWidth",
});
